jQuery.feature_import("js-reports",
    () => require("./reports.jsx"),
    mod => mod.feature_js_reports
);